import { Tabs } from '@inflearn/ds-react';
import Link from 'next/link';

import { MY_URL } from '../../../constants/urls';
import { useCurrentUrl } from '../../../hooks/useCurrentUrl';

export function MyGiftsTabs() {
  const { currentUrlWithoutQueryString } = useCurrentUrl();

  return (
    <Tabs
      styles={{
        tabsList: {
          flexWrap: 'nowrap',
        },
      }}
      value={currentUrlWithoutQueryString}
      wrap="nowrap"
      mb={24}
    >
      <Tabs.List>
        <Tabs.Tab component={Link} value={MY_URL.GIFTS_RECEIVED()} href={MY_URL.GIFTS_RECEIVED()}>
          받은 선물
        </Tabs.Tab>
        <Tabs.Tab component={Link} value={MY_URL.GIFTS_SENT()} href={MY_URL.GIFTS_SENT()}>
          보낸 선물
        </Tabs.Tab>
      </Tabs.List>
    </Tabs>
  );
}
